import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "shop-form__block _form" }
const _hoisted_2 = {
  key: 0,
  class: "text"
}
const _hoisted_3 = { class: "inputwrapper" }
const _hoisted_4 = {
  key: 1,
  class: "inputwrapper"
}
const _hoisted_5 = {
  key: 2,
  class: "confirm"
}
const _hoisted_6 = { class: "number" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "ready" }, "Подтверждено", -1)
const _hoisted_8 = {
  key: 3,
  class: "inputwrapper"
}
const _hoisted_9 = ["disabled"]

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds } from "@/types";
import { IloyalityShopData, TypeReceiver } from "@/types/typesOfState";
import nextElementFocus from '@/functions/nextElementFocus'


export default /*#__PURE__*/_defineComponent({
  __name: 'stepForm',
  setup(__props, { expose: __expose }) {

const store = useStore();

const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);

const receiver = computed<TypeReceiver>(
  () => store.state.loyalityShopData.receiver
);

const clientData = computed(() => loyalityShopData.value.clientData);
const buyerData = computed(() => loyalityShopData.value.buyerData);

const nameInput = ref<HTMLInputElement | null>(null);
const phoneInput = ref<any>(null);
const emailInput = ref<HTMLInputElement | null>(null);
const emailRecipientInput = ref<HTMLInputElement | null>(null);

let invalidName = ref<boolean>(false);
let invalidPhone = ref<boolean>(false);
let invalidEmail = ref<boolean>(false);

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateClientData(): boolean {
  const clientName = loyalityShopData.value.clientData.name || null;
  const clientPhone = loyalityShopData.value.clientData.phone ? loyalityShopData.value.clientData.phone.replace("+", "").replace(/\s+/g, "") : null;
  const clientEmail = loyalityShopData.value.clientData.email || null;
  if (
    !clientName ||
    clientName.length < 2
  ) {
    invalidName.value = true;

    nameInput?.value?.focus();
    return false;
  } else {
    invalidName.value = false;
  }

  if (
    !clientPhone ||
    clientPhone.length < 11
  ) {
    invalidPhone.value = true;

    console.log(phoneInput);
    phoneInput?.value?.$el.focus();
    return false;
  } else {
    invalidPhone.value = false;
  }

  if (receiver.value === "self") {
    const validatorValue =
      !!clientEmail &&
      emailRegex.test(clientEmail);

    if (validatorValue === false) {
      invalidEmail.value = true;
      return false;
    } else {
      invalidEmail.value = false;
    }
  }

  return true;
}

// Экспортируем метод, чтобы он был доступен из родительского компонента
__expose({ validateClientData });

return (_ctx: any,_cache: any) => {
  const _component_MaskInput = _resolveComponent("MaskInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loyalityShopData.value.receiver === 'other')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " На кого оформить подарок "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_unref(invalidName))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "errorblock close",
            onClick: _cache[0] || (_cache[0] = (event) => {_unref(nextElementFocus)(event); _isRef(invalidName) //@ts-ignore
 ? invalidName.value = false : invalidName = false; })
          }, "Укажите корректное имя"))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["input", { error: _unref(invalidName) }]),
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientData.value.name) = $event)),
        ref_key: "nameInput",
        ref: nameInput,
        placeholder: 'Имя фамилия'
        
      }, null, 2), [
        [_vModelText, clientData.value.name]
      ])
    ]),
    (
        receiver.value === 'other' || (receiver.value === 'self' && !_ctx.$store.getters.isAuth)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(invalidPhone))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "errorblock close",
                onClick: _cache[2] || (_cache[2] = (event) => {_unref(nextElementFocus)(event); _isRef(invalidPhone) //@ts-ignore
 ? invalidPhone.value = false : invalidPhone = false; })
              }, "Укажите корректный телефон"))
            : _createCommentVNode("", true),
          _createVNode(_component_MaskInput, {
            modelValue: clientData.value.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((clientData.value.phone) = $event)),
            ref_key: "phoneInput",
            ref: phoneInput,
            class: _normalizeClass(["input", { error: _unref(invalidPhone) }]),
            type: "tel",
            mask: '+7 ### ### ## ## ##',
            placeholder: "+ *** *** ** **"
          }, null, 8, ["modelValue", "class"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).state.authModule.authPhone), 1),
          _hoisted_7
        ])),
    (receiver.value === 'self')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(invalidEmail))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "errorblock close",
                onClick: _cache[4] || (_cache[4] = (event) => {_unref(nextElementFocus)(event); _isRef(invalidEmail) //@ts-ignore
 ? invalidEmail.value = false : invalidEmail = false; })
              }, "Укажите корректный Email"))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input post _disabled-text-hide", {
          error: _unref(invalidEmail) && loyalityShopData.value.emailRecipient === 'self',
        }]),
            type: "text",
            placeholder: "Почта",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((clientData.value.email) = $event)),
            ref_key: "emailInput",
            ref: emailInput,
            disabled: loyalityShopData.value.emailRecipient !== 'self'
          }, null, 10, _hoisted_9), [
            [_vModelText, clientData.value.email]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})